import logoImage from '../assets/images/i_want_to_create_a_202605132257.png';

export const SITE_NAME = 'أكاديمية الفاروق للعلوم الشرعية';
export const SITE_SHORT_NAME = 'أكاديمية الفاروق';

export const SITE_DESCRIPTION =
  'أكاديمية الفاروق للعلوم الشرعية — منصة لطلب العلم الشرعي: عقيدة، فقه، سيرة، وحديث، بمنهج أهل السنة والجماعة.';

export const SITE_KEYWORDS =
  'أكاديمية الفاروق, علوم شرعية, طلب العلم, أهل السنة والجماعة, فقه, عقيدة, حديث, سيرة';

export const SITE_THEME_COLOR = '#065f46';
export const SITE_BACKGROUND_COLOR = '#ecfdf5';

/** Optional production site URL for Open Graph (set REACT_APP_SITE_URL in .env) */
export const SITE_URL =
  (typeof process !== 'undefined' && process.env.REACT_APP_SITE_URL) || '';

export const siteLogo = logoImage;
